/* tslint:disable */
/* eslint-disable */
/**
 * Rooming_API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Event,
    EventFromJSON,
    EventFromJSONTyped,
    EventToJSON,
} from './';

/**
 * 
 * @export
 * @interface Discipline
 */
export interface Discipline {
    /**
     * 
     * @type {number}
     * @memberof Discipline
     */
    disciplineId?: number;
    /**
     * 
     * @type {string}
     * @memberof Discipline
     */
    sportCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Discipline
     */
    sportName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Discipline
     */
    disciplineName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Discipline
     */
    disciplineCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Discipline
     */
    fullName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Discipline
     */
    deleted?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Discipline
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Discipline
     */
    modified?: Date;
    /**
     * 
     * @type {Event}
     * @memberof Discipline
     */
    event?: Event;
    /**
     * 
     * @type {string}
     * @memberof Discipline
     */
    createdBy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Discipline
     */
    modifiedBy?: string | null;
}

export function DisciplineFromJSON(json: any): Discipline {
    return DisciplineFromJSONTyped(json, false);
}

export function DisciplineFromJSONTyped(json: any, ignoreDiscriminator: boolean): Discipline {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'disciplineId': !exists(json, 'disciplineId') ? undefined : json['disciplineId'],
        'sportCode': !exists(json, 'sportCode') ? undefined : json['sportCode'],
        'sportName': !exists(json, 'sportName') ? undefined : json['sportName'],
        'disciplineName': !exists(json, 'disciplineName') ? undefined : json['disciplineName'],
        'disciplineCode': !exists(json, 'disciplineCode') ? undefined : json['disciplineCode'],
        'fullName': !exists(json, 'fullName') ? undefined : json['fullName'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'modified': !exists(json, 'modified') ? undefined : (new Date(json['modified'])),
        'event': !exists(json, 'event') ? undefined : EventFromJSON(json['event']),
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : json['modifiedBy'],
    };
}

export function DisciplineToJSON(value?: Discipline | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'disciplineId': value.disciplineId,
        'sportCode': value.sportCode,
        'sportName': value.sportName,
        'disciplineName': value.disciplineName,
        'disciplineCode': value.disciplineCode,
        'fullName': value.fullName,
        'deleted': value.deleted,
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'modified': value.modified === undefined ? undefined : (value.modified.toISOString()),
        'event': EventToJSON(value.event),
        'createdBy': value.createdBy,
        'modifiedBy': value.modifiedBy,
    };
}

